import React from 'react';
import Ball from './Ball';
import Content from './Content';
var Step = function (_a) {
    var header = _a.header, content = _a.content, title = _a.title;
    return (React.createElement("div", { className: 'timeline__step' },
        React.createElement(Ball, null),
        React.createElement(Content, { title: title, content: content, header: header })));
};
export default Step;
